/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_repliesComment = {
    readonly id: string;
    readonly replyCount: number;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
    readonly " $refType": "ReplyListContainer_repliesComment";
};
export type ReplyListContainer_repliesComment$data = ReplyListContainer_repliesComment;
export type ReplyListContainer_repliesComment$key = {
    readonly " $data"?: ReplyListContainer_repliesComment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_repliesComment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer_repliesComment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "replyCount",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_comment"
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '6350a586a023b6d8ffc9c3b2b42fec6b';
export default node;
